import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_CURRENT_DIALOG = 'CLOSE_CURRENT_DIALOG';
export const SET_IS_DIALOG_ACTIVE = 'SET_IS_DIALOG_ACTIVE';
export const OPENING_DIALOG = 'OPENING_DIALOG';
export const CLOSE_ALL_DIALOGS = 'CLOSE_ALL_DIALOGS';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[OPENING_DIALOG](state, value) {
		Vue.set(state, 'openingDialog', value);
	},
	[OPEN_DIALOG](state, payload) {
		state.openDialogs.push({ ...payload, dialogProps: payload.dialogProps, dialogListeners: payload.dialogListeners });
	},
	[CLOSE_CURRENT_DIALOG](state) {
		state.openDialogs.pop();
	},
	[CLOSE_ALL_DIALOGS](state) {
		Vue.set(state, 'openDialogs', []);
	},
	// state.isDialogActive used by UserMatchingMixin only,
	// go to `$data._userMatchingDialog` watch in UserMatchingMixin before extending the use of if.
	// probably if you want to use it to another use case, you should do it through AppDialogManager
	// it's here to allow manually mark as there is opened dialog, even though it wasn't open from dialogs store module
	[SET_IS_DIALOG_ACTIVE](state, value) {
		Vue.set(state, 'isDialogActive', value);
	},
};

export default mutations;
